/*
 * Header Layout
 */

define(["marionette", "modules/header/template/headerTemplate.html"], function (
  Marionette,
  HeaderTemplate,
) {
  var HeaderView = {};

  HeaderView.headerLayout = Marionette.Layout.extend({
    template: HeaderTemplate,
    regions: {
      contextMenu: "#context-menu",
      menuBar: "#menu-bar",
      kbMenu: "#kbMenuDropdown",
      userMenu: "#user-menu",
      refreshMenu: "#kbRefresh",
    },
    triggers: {
      "click #home": "click:home",
    },
    activateHomeButton: function () {
      this.$el.find("#home").addClass("active");
    },
    deactivateHomeButton: function () {
      this.$el.find("#home").removeClass("active");
    },
  });

  return HeaderView;
});
